import { TicketSelectionValidationResult, validateOrderTicketsForShowtime } from '@vista/omnichannel-components-domain'

export function validateSelectedTickets(showtimeId: string): TicketSelectionValidationResult {
    return validateOrderTicketsForShowtime(showtimeId)
}
